import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d7b15ca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2d7b15ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b15ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7b15ca')) {
      api.createRecord('2d7b15ca', component.options)
    } else {
      api.reload('2d7b15ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d7b15ca&scoped=true&", function () {
      api.rerender('2d7b15ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/representative/index.vue"
export default component.exports